export const scene2Frames = [
  // 1
  {
    url: 'Scene1',
    position: {
      yaw: 124.45 * Math.PI / 180,
      pitch: -1.7 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(600px) rotateY(-33deg) skewY(-2.5deg) scale(0.125)'
      }
    },
    style: {
      width: '840px',
      height: '720px',
      backgroundSize: 'contain',
    }
  },
  // 2
  {
    url: 'Scene2',
    position: {
      yaw: 136.65 * Math.PI / 180,
      pitch: -2.25 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(500px) rotateY(-22deg) skewY(-2deg) scale(0.2)'
      }
    },
    style: {
      width: '785px',
      height: '560px',
      backgroundSize: 'contain',
    }
  },
  // 3
  {
    url: 'Scene3',
    position: {
      yaw: 155.8 * Math.PI / 180,
      pitch: -2.9 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(200px) rotateY(-5deg) skewY(-1deg) scale(0.333333333)'
      }
    },
    style: {
      width: '684px',
      height: '420px',
      backgroundSize: 'contain',
    }
  },
  // 10
  {
    url: 'Scene10',
    position: {
      yaw: -37.4 * Math.PI / 180,
      pitch: -2.6 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(600px) rotateY(-17deg) rotateX(0deg) skewX(0deg) skewY(-1.5deg) scale(0.25)'
      }
    },
    style: {
      width: '736px',
      height: '500px',
      backgroundSize: 'contain',
    }
  },
  // 11
  {
    url: 'Scene11',
    position: {
      yaw: 6.15 * Math.PI / 180,
      pitch: -3.15 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(200px) rotateY(2deg) rotateX(0deg) skewX(0deg) skewY(0.5deg) scale(0.33333333)'
      }
    },
    style: {
      width: '810px',
      height: '462px',
      backgroundSize: 'contain',
    }
  },
  // 12
  {
    url: 'Scene12',
    position: {
      yaw: 40.6 * Math.PI / 180,
      pitch: -2.35 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(100px) rotateY(6deg) rotateX(0deg) skewX(0deg) skewY(2deg) scale(0.2)'
      }
    },
    style: {
      width: '790px',
      height: '585px',
      backgroundSize: 'contain',
    }
  },
];
